import React from 'react';

const Footer = () => {
  return (
    <footer style={styles.footer}>
      <div className="container">
        <p>&copy; {new Date().getFullYear()} RealEstatePro. All rights reserved.</p>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    backgroundColor: '#2c3e50',
    color: 'white',
    padding: '1.5rem 0',
    marginTop: 'auto',
    textAlign: 'center'
  }
};

export default Footer;